import React from 'react';
import { ShieldCheckIcon, MapPinIcon, MessageCircleIcon, ClockIcon } from 'lucide-react';
export function TrustSignals() {
  const signals = [{
    icon: ShieldCheckIcon,
    text: 'Atención profesional y ordenada'
  }, {
    icon: MapPinIcon,
    text: 'Cobertura completa en Costa Rica'
  }, {
    icon: MessageCircleIcon,
    text: 'Comunicación directa por WhatsApp'
  }, {
    icon: ClockIcon,
    text: 'Trámite listo en tiempo récord: 48 hrs'
  }];
  return <section className="w-full bg-white py-20 px-4" data-id="element-76">
      <div className="max-w-6xl mx-auto" data-id="element-77">
        <div className="text-center mb-12" data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4" data-id="element-79">
            Por qué elegirnos
          </h2>
          <p className="text-xl text-gray-600" data-id="element-80">
            Líderes en certificación de Gas LP en Costa Rica
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-81">
          {signals.map((signal, index) => {
          const Icon = signal.icon;
          return <div key={index} className="text-center group" data-id="element-82">
                <div className="w-20 h-20 bg-gradient-to-br from-jazugas-blue to-jazugas-blue/80 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg" data-id="element-83">
                  <Icon className="w-10 h-10 text-white" aria-hidden="true" data-id="element-84" />
                </div>
                <p className="text-gray-800 font-semibold text-lg" data-id="element-85">
                  {signal.text}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}